module.exports = __webpack_public_path__ + "img/76.1ee39ad4.jpg";